import React from 'react'
import Button from '../Button'
import styled from 'styled-components'

const StyledButtonAndText = styled.div`
  align-items:center;
  display:flex;
  flex-direction:column;
  justify-content:center;
  margin-top:32px;

  ${({theme}) => theme.media.desktop}{
    flex-direction: row;
  }
`

const StyledText = styled.p`
  color: ${({ theme }) => theme.colors.greyParagraphColor};
  font-size: 0.875em;
  margin-left: 8px;
  margin-top: 16px;

  ${({theme}) => theme.media.desktop}{
    margin-top: 0px;
  }
`

const ButtonAndText = ({cmsData}) => {
    return (
      <StyledButtonAndText>
        <Button cmsData={cmsData.button.fields} />
        <StyledText>{cmsData.text}</StyledText>
      </StyledButtonAndText>
    )
}

export default ButtonAndText